import { usePerformant } from '@sohanscript/lib/hooks/performant';
import { ReactLenis } from 'lenis/react';

export function LenisScroll() {
	const isPerformant = usePerformant();
	return <>{isPerformant && <ReactLenis root />}</>;
}
